import React from 'react';
import PropTypes from 'prop-types';
import { SearchIcon, TableFilterTagIcon, UnselectIcon } from '../svgIcon';
import { getI18Next } from '../../../utils/helpers';

function SearchBox(props) {
  const currentLanguageCode = getI18Next();
  let cardStyle = {};
  if (currentLanguageCode === 'ar') {
    cardStyle = {
      padding: '0 10px 0 0',
    };
  }
  const changes = (e) => {
    props?.change(e.target.name, e.target.value);
  };
  const handleFilterTagRemove = (tag) => {
    // props?.setFilterTag((prevFilterArray) => prevFilterArray.filter(
    //   (filters) => !(filters?.filter_by === tag?.filter_by && filters?.result === tag?.result),
    // ));
    if (tag?.filterBy === 'Date Uploaded' || tag?.key === 'startDate' || tag?.key === 'endDate') {
      props?.setFilterTag(props?.filterTag.filter(
        (filters) => !(filters?.filterBy === tag?.filterBy),
      ), 'remove');
    } else {
      props?.setFilterTag(props?.filterTag.filter(
        (filters) => !(filters?.filterBy === tag?.filterBy && filters?.result === tag?.result),
      ), 'remove');
    }
  };
  return (
    <div
      className="search-input-wrap"
      style={cardStyle}
    >
      <span><SearchIcon /></span>
      {!props?.filterTag?.length
        && (
          <input
            type={props?.type}
            name={props?.name}
            className="search-input-box"
            value={props?.value}
            onChange={changes}
            readOnly={props?.readOnly}
            placeholder={props?.placeholder}
            id={props?.name}
            maxLength={props?.maxLength}
            autoComplete="off"
          />
        )}
      {props?.filterTag?.length > 0
        && (
          <div className="table-filter-view-wrapper-playlist">
            <div className={props?.filterTag?.length <= 1 ? 'table-filter-view' : 'table-filter-view-expand'}>
              {props?.filterTag?.map((value) => (
                <div className="filter-tag" key={value}>
                  <span><TableFilterTagIcon /></span>
                  <span>{value?.filterBy}</span> :
                  <span>{value?.result}</span>
                  <span onClick={() => handleFilterTagRemove(value)} role="none"><UnselectIcon /></span>
                </div>
              ))}
            </div>
            {/* <p onClick={handleClear} role="none">Clear({props?.filterTag?.length})</p> */}
          </div>
        )}
    </div>
  );
}

SearchBox.propTypes = {
  type: PropTypes.string.isRequired,
  readOnly: PropTypes.bool,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  change: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
  filterTag: PropTypes.arrayOf.isRequired,
  setFilterTag: PropTypes.func.isRequired,
};

SearchBox.defaultProps = {
  readOnly: false,
  value: '',
  placeholder: '',
  maxLength: Infinity,
};

export default SearchBox;
